import { render } from "./CatImpuestoView.vue?vue&type=template&id=261d6ba9&scoped=true"
import script from "./CatImpuestoView.vue?vue&type=script&lang=js"
export * from "./CatImpuestoView.vue?vue&type=script&lang=js"

import "./CatImpuestoView.vue?vue&type=style&index=0&id=261d6ba9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261d6ba9"]])

export default __exports__